'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var mobx = require('mobx');
var omitBy = require('lodash/omitBy');
var mapValues = require('lodash/mapValues');
var get = require('lodash/get');
var isNull = require('lodash/isNull');
var isObject = require('lodash/isObject');
var every = require('lodash/every');
var forEach = require('lodash/forEach');
var some = require('lodash/some');
var isFinite = require('lodash/isFinite');
var isEqual = require('lodash/isEqual');
var moment = require('moment');
var last = require('lodash/last');
var flat = require('flat');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var omitBy__default = /*#__PURE__*/_interopDefaultLegacy(omitBy);
var mapValues__default = /*#__PURE__*/_interopDefaultLegacy(mapValues);
var get__default = /*#__PURE__*/_interopDefaultLegacy(get);
var isNull__default = /*#__PURE__*/_interopDefaultLegacy(isNull);
var isObject__default = /*#__PURE__*/_interopDefaultLegacy(isObject);
var every__default = /*#__PURE__*/_interopDefaultLegacy(every);
var forEach__default = /*#__PURE__*/_interopDefaultLegacy(forEach);
var some__default = /*#__PURE__*/_interopDefaultLegacy(some);
var isFinite__default = /*#__PURE__*/_interopDefaultLegacy(isFinite);
var isEqual__default = /*#__PURE__*/_interopDefaultLegacy(isEqual);
var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);
var last__default = /*#__PURE__*/_interopDefaultLegacy(last);
var flat__default = /*#__PURE__*/_interopDefaultLegacy(flat);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/**
 * Support any input that may contains decimals
 * and other stuff. Check the test cases to understand
 * which cases we handle.
 *
 * Improve this if you find how.
 */
function numberParser(str) {
    var cleanString = str.replace(/[^\d,.-]/g, '');
    var sign = cleanString.charAt(0) === '-' ? '-' : '+';
    var parts = cleanString.split(/[.,]/);
    var decimals = parts.length > 1 && last__default['default'](parts).length < 3
        ? parts.pop()
        : null;
    var number = parts.join('').replace(/[.,]\d*$/, '').replace(/\D/g, '');
    return Number(sign + number + (decimals ? '.' + decimals : ''));
}

var DATE_FORMAT = 'L';
var Field = /** @class */ (function () {
    function Field(value, type) {
        this.type = type;
        this.mapAndSet(value);
        this.originalValue = this.value;
        this.errors = null;
        mobx.makeObservable(this, {
            value: mobx.observable,
            errors: mobx.observable,
            originalValue: mobx.observable,
            isDirty: mobx.computed,
            hasValue: mobx.computed,
            mapAndSet: mobx.action,
            set: mobx.action,
            clean: mobx.action,
            setErrors: mobx.action
        });
    }
    /**
     * Converts the incoming value
     * before being persisted in the field
     */
    Field.prototype._mapIn = function (value) {
        if (value == null)
            return '';
        switch (this.type) {
            case 'timestamp':
                if (typeof value !== 'number')
                    throw new Error('Fields expects a number');
                return moment__default['default'].unix(value).format(DATE_FORMAT);
            case 'date':
                if (typeof value !== 'string')
                    throw new Error('Fields expects an string');
                return moment__default['default'](value, 'YYYY-MM-DD', true).format(DATE_FORMAT);
            case 'number':
                if (typeof value !== 'number')
                    throw new Error('Fields expects a number');
                return value.toString();
            case 'cents':
                if (typeof value !== 'number')
                    throw new Error('Fields expects a number');
                return (value / 100).toString();
            case 'boolean':
            case 'string':
            case 'file':
            case 'any':
                return value;
            default:
                throw new Error("unknown field type: " + this.type);
        }
    };
    /**
     * Converts back the value from the field
     */
    Field.prototype._mapOut = function () {
        var value = typeof this.value === 'string'
            ? this.value.trim()
            : this.value;
        switch (this.type) {
            case 'timestamp':
                return moment__default['default'].utc(String(value), DATE_FORMAT).unix() || null;
            case 'date':
                var date = moment__default['default'](String(value), DATE_FORMAT, true);
                return date.isValid() ? date.format('YYYY-MM-DD') : null;
            case 'number':
                var number = numberParser(typeof value === 'number' ? value.toString() : String(value));
                return number != null && isFinite__default['default'](number) ? Math.round(number) : null;
            case 'cents':
                var cents = numberParser(typeof value === 'number' ? value.toString() : String(value));
                return cents != null && isFinite__default['default'](cents) ? Math.round(cents * 100) : null;
            case 'boolean':
                return value;
            case 'string':
            case 'file':
            case 'any':
                return value || null;
            default:
                throw new Error("unknown field type: " + this.type);
        }
    };
    Object.defineProperty(Field.prototype, "isDirty", {
        get: function () {
            return !isEqual__default['default'](this.originalValue, this.value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "hasValue", {
        get: function () {
            switch (this.type) {
                case 'number':
                case 'cents':
                case 'boolean':
                    return this.value !== '' && !isNull__default['default'](this.value);
                default:
                    return !!this.value;
            }
        },
        enumerable: false,
        configurable: true
    });
    Field.prototype.mapAndSet = function (value) {
        this.value = this._mapIn(value);
    };
    Field.prototype.set = function (value) {
        this.value = value;
    };
    Field.prototype.clean = function () {
        this.originalValue = this.value;
    };
    Field.prototype.reset = function () {
        this.value = this.originalValue;
    };
    Field.prototype.setErrors = function (errors) {
        this.errors = errors;
    };
    return Field;
}());

var buildFields = function (values, schema) {
    return omitBy__default['default'](mapValues__default['default'](flat__default['default'](schema), function (value, attribute) {
        return isObject__default['default'](value)
            ? null
            : new Field(get__default['default'](values, attribute), value);
    }), isNull__default['default']);
};
var Form = /** @class */ (function () {
    function Form(values, schema) {
        this.fields = buildFields(values, schema);
        mobx.makeObservable(this, {
            cleanAll: mobx.action,
            resetErrors: mobx.action,
            setErrors: mobx.action,
            resetValues: mobx.action,
            setValues: mobx.action,
            handleErrors: mobx.action,
            isComplete: mobx.computed,
            values: mobx.computed,
            isDirty: mobx.computed,
            serialized: mobx.computed,
            hasErrors: mobx.computed,
            dirtyFieldsKeys: mobx.computed,
            fieldsWithValueKeys: mobx.computed,
        });
    }
    Object.defineProperty(Form.prototype, "serialized", {
        get: function () {
            return flat__default['default'].unflatten(mapValues__default['default'](this.fields, function (field) { return field._mapOut(); }));
        },
        enumerable: false,
        configurable: true
    });
    // @deprecated
    Form.prototype.data = function () {
        return this.serialized;
    };
    Form.prototype.has = function (attribute) {
        return Boolean(this.fields[attribute]);
    };
    Form.prototype.get = function (attribute) {
        var field = this.fields[attribute];
        if (!field)
            throw new Error("Field \"" + attribute + "\" not found");
        return field;
    };
    /**
     * Cleans all the forms by changing their original
     * values to correspond to their current values
     */
    Form.prototype.cleanAll = function () {
        forEach__default['default'](this.fields, function (field) {
            return field.clean();
        });
    };
    /**
     * Reset all the forms to their original
     * values thereby discarding all changes made
     */
    Form.prototype.resetAll = function () {
        forEach__default['default'](this.fields, function (field) {
            return field.reset();
        });
    };
    /**
     * Resets all the error fields
     */
    Form.prototype.resetErrors = function () {
        forEach__default['default'](this.fields, function (field) {
            field.setErrors(null);
        });
    };
    /**
     * Sets the errors with a given
     * hash of attribute -> error
     */
    Form.prototype.setErrors = function (errors) {
        var _this = this;
        this.resetErrors();
        var flatErrors = flat__default['default'](errors, { safe: true });
        forEach__default['default'](flatErrors, function (error, attribute) {
            if (_this.has(attribute)) {
                _this.get(attribute).setErrors(error);
            }
        });
    };
    Object.defineProperty(Form.prototype, "isComplete", {
        /**
         * Checks if all fields have a value.
         */
        get: function () {
            return every__default['default'](this.fields, function (field) { return field.hasValue; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Form.prototype, "values", {
        /**
         * Return the values from the form as they are
         */
        get: function () {
            return mapValues__default['default'](this.fields, function (field) { return field.value; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Form.prototype, "isDirty", {
        /**
         * Return whether the form is dirty
         */
        get: function () {
            return some__default['default'](this.fields, function (field) { return field.isDirty; });
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Reset values
     */
    Form.prototype.resetValues = function () {
        forEach__default['default'](this.fields, function (field) { return field.set(''); });
    };
    /**
     * Sets the fields values with a given
     * hash of attribute -> value
     */
    Form.prototype.setValues = function (values) {
        var _this = this;
        forEach__default['default'](values, function (value, attribute) {
            if (!_this.has(attribute))
                return;
            var field = _this.get(attribute);
            field.setErrors(null);
            field.mapAndSet(value);
        });
    };
    /**
     * Creates a new model on the given collection
     */
    Form.prototype.create = function (collection) {
        var _this = this;
        return this.handleErrors(function () { return collection.create(_this.data()); });
    };
    /**
     * Saves the model with the given fields
     */
    Form.prototype.save = function (model, options) {
        var _this = this;
        if (options === void 0) { options = { patch: true }; }
        return this.handleErrors(function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, model.save(this.data(), options)];
        }); }); });
    };
    Form.prototype.handleErrors = function (fn) {
        return __awaiter(this, void 0, void 0, function () {
            var values, _a, error_1, payload_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = mobx.toJS;
                        return [4 /*yield*/, fn()];
                    case 1:
                        values = _a.apply(void 0, [_b.sent()]);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        payload_1 = error_1.payload;
                        mobx.action('handleErrors-error', function () {
                            _this.setErrors(mobx.toJS(payload_1 || error_1));
                            _this.cleanAll();
                        })();
                        throw error_1;
                    case 3:
                        mobx.action('handleErrors-done', function () {
                            _this.setValues(values);
                            _this.resetErrors();
                            _this.cleanAll();
                        })();
                        return [2 /*return*/, values];
                }
            });
        });
    };
    Object.defineProperty(Form.prototype, "hasErrors", {
        /**
         * whether if any of the fields have an error
         */
        get: function () {
            return some__default['default'](this.fields, function (field) { return field.errors !== null; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Form.prototype, "dirtyFieldsKeys", {
        /**
         * returns an array of strings with the keys
         * of the fields that are dirty
         */
        get: function () {
            return Object.entries(this.fields)
                .filter(function (_a) {
                var _b = __read(_a, 2); _b[0]; var field = _b[1];
                return field.isDirty;
            })
                .map(function (_a) {
                var _b = __read(_a, 2), key = _b[0]; _b[1];
                return key;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Form.prototype, "fieldsWithValueKeys", {
        /**
         * returns an array of strings with the keys
         * of the fields that has value
         */
        get: function () {
            return Object.entries(this.fields)
                .filter(function (_a) {
                var _b = __read(_a, 2); _b[0]; var field = _b[1];
                return field.hasValue;
            })
                .map(function (_a) {
                var _b = __read(_a, 2), key = _b[0]; _b[1];
                return key;
            });
        },
        enumerable: false,
        configurable: true
    });
    return Form;
}());

exports.Field = Field;
exports.Form = Form;
exports.numberParser = numberParser;
